import type { TFunction } from 'i18next';
import type { AssessmentResultItemDataFragment } from '../../../Trainee/TraineeReports.api';
import type { PhysiologicalResult } from '../../model';
import parseCardioResp from './parseCardioResp';
import parseStrength from './parseStrength';
import { buildCardioRespPlaceholder, buildStrengthPlaceholder } from './placeholders';

const parsePhysiologicalResults = (
    t: TFunction,
    items: AssessmentResultItemDataFragment[],
    incompleteItems: AssessmentResultItemDataFragment[] = []
): PhysiologicalResult[] => {
    const incompleteModuleInstanceIds = new Set(incompleteItems.map(i => i.moduleInstance?.id));

    const completedItems = items.filter(
        i => !i.moduleInstance?.id || !incompleteModuleInstanceIds.has(i.moduleInstance.id)
    );

    const results: PhysiologicalResult[] = [];

    // Strength
    const completedStrength = parseStrength(t, completedItems);
    if (completedStrength) {
        results.push(completedStrength);
    } else {
        const incompleteStrength = incompleteItems.find(
            i => i.moduleInstance?.moduleDefinitionIdentifier === 'strength-assessment'
        );
        if (incompleteStrength) {
            const p = buildStrengthPlaceholder(t, incompleteStrength);
            if (p) {
                results.push(p);
            }
        }
    }

    // Cardio Respiratory
    const completedCardio = parseCardioResp(t, completedItems);
    if (completedCardio) {
        results.push(completedCardio);
    } else {
        const incompleteCardio = incompleteItems.find(
            i => i.moduleInstance?.moduleDefinitionIdentifier === 'cardio-respiratory'
        );
        if (incompleteCardio) {
            const p = buildCardioRespPlaceholder(t, incompleteCardio);
            if (p) {
                results.push(p);
            }
        }
    }

    return results;
};

export default parsePhysiologicalResults;
